import { Loader2, Mic, MicOff } from "lucide-react";

export default function RecordingControls({
  recording,
  transcribing,
  supportsRecording,
  onStart,
  onStop,
}) {
  if (transcribing) {
    return (
      <div
        className="inline-flex items-center gap-2 text-slate-500"
        data-testid="voice-transcribing"
      >
        <Loader2 className="h-4 w-4 animate-spin" /> Transcribing…
      </div>
    );
  }
  if (recording) {
    return (
      <button
        type="button"
        onClick={onStop}
        className="inline-flex items-center gap-2 rounded-full bg-rose-600 text-white px-5 py-2.5 text-sm font-medium shadow-lg hover:bg-rose-700"
        data-testid="voice-stop-button"
        aria-label="Stop recording"
      >
        <MicOff className="h-4 w-4" /> Stop
      </button>
    );
  }
  return (
    <button
      type="button"
      onClick={onStart}
      disabled={!supportsRecording}
      className="inline-flex items-center gap-2 rounded-full bg-emerald-600 text-white px-5 py-2.5 text-sm font-medium shadow-lg hover:bg-emerald-700 disabled:opacity-50"
      data-testid="voice-record-button"
      aria-label="Start recording"
    >
      <Mic className="h-4 w-4" /> Record
    </button>
  );
}
